import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeDomainPrefixSuffix'
})
export class RemoveDomainPrefixSuffixPipe implements PipeTransform {

  transform(value: string): string {
    // Remove "https://www." from the beginning of the URL
    let modifiedUrl = value.replace(/https?:\/\/(www\.)?/i, '');
    // Remove ".com" from the end of the URL
    modifiedUrl = modifiedUrl.replace('.com/', '');
    modifiedUrl = modifiedUrl.replace('.in/', '');
    modifiedUrl = modifiedUrl.replace('.co.in/', '');
    modifiedUrl = modifiedUrl.replace('.org/', '');
    modifiedUrl = modifiedUrl.replace('.com', '');
    modifiedUrl = modifiedUrl.replace('.in', '');
    modifiedUrl = modifiedUrl.replace('.co.in', '');
    modifiedUrl = modifiedUrl.replace('.org', '');

    return modifiedUrl;
  }

}
